import { render, staticRenderFns } from "./SSSalonEditorView.vue?vue&type=template&id=1944367f&scoped=true&"
import script from "./SSSalonEditorView.vue?vue&type=script&lang=js&"
export * from "./SSSalonEditorView.vue?vue&type=script&lang=js&"
import style0 from "./SSSalonEditorView.vue?vue&type=style&index=0&id=1944367f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944367f",
  null
  
)

export default component.exports